import type { QueryKey } from '@tanstack/react-query';

const queryKeys = {
  groups: ['api', 'v1', 'groups'] as QueryKey,
  jobStatus: ['api', 'v1', 'job_status'] as QueryKey,
};
export default queryKeys;